import React, { Component } from 'react';

/**
 * src和name不可变。
 */
export default class LazyComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { App: null };
    }

    componentDidMount() {
        this.createScript();
    }

    render() {
	    let { App } = this.state,
	        { props } = this.props;

	    return App ? <App {...props} /> : null;
    }

	createScript = () => {
	    let { src, name } = this.props;
		
	    if (!src || !name) {
	        return;
	    }

	    var scripts = Array.from(document.getElementsByTagName('script')),
	        script = scripts.find(e => {
	            return e.src.includes(src);
	        });

	    if (window[name]) {
	        // 已经加载过script标签
	        this.handleLoad();
	    } else {
	        if (!script) {
	            script = document.createElement('script');
	            script.src = src;
	            script.type = 'text/javascript';
	            document.body.appendChild(script);
	        }

	        script.addEventListener('load', this.handleLoad);
	        this.script = script;
	    }
	};

	handleLoad = () => {
	    let { name, exportName = 'default', onLoad } = this.props;

	    this.setState({ App: window[name]?.[exportName] });

		onLoad?.();
	    this.script?.removeEventListener('load', this.handleLoad);
	}
}

// DEMO:
// import { base } from 'nc-lightapp-front';

// const { NCLazyComponent: LazyComponent } = base;

// class App extends Component {
//     render() {
//         return <LazyComponent
//             src='../../../../uap/common/components/approvalTrans/index.js' // js路径
//             name='uap/common/components/approvalTrans/index' // window上全局变量的名字
//             exportName='default' // export default的话，传'default'；export { App }的话，传'App'。默认'default'。
//             onLoad={function () {}} // 组件加载完的回调
//             props={{}} //  ApprovalTrans需要的props
//         />;
//     }
// }
